import { requireNativeModule } from 'expo-modules-core';

const ExpoAppleWalletModule = requireNativeModule('ExpoAppleWallet');

export default ExpoAppleWalletModule;
